import MuiPaginationItem, {
  type PaginationItemProps,
} from "@mui/material/PaginationItem";

export type { PaginationItemProps };

export function PaginationItem(props: PaginationItemProps) {
  return <MuiPaginationItem {...props} />;
}
